module.exports = __webpack_public_path__ + "img/teacher-pic002.b883d141.png";